import React from "react";
import { Modal, Button, Dropdown, Spinner } from "react-bootstrap";
import "./HiringProcess.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faCircleInfo, faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import useHiringProcess from "./useHiringProcess";
import { dateFormatter } from "../../../../_helpers/dateFormatter";
import TextEditor from "../../../Common/Editor";
function HiringProcess(props) {
  const {
    stageLoading,
    commentLoading,
    openCommentInput,
    commentText,
    deleteCommentModal,
    deleteCommentId,
    editCommentIndex,
    editCommentText,
    editCommentLoading,
    currentTab,
    activeStage,
    userType,
    hiringProgressInfoData,
    isOfferTermsModalOpen,
    offerTermsFormData,
    offerTermsAdded,
    offerTermsAddedLoading,

    currentTabHandler,
    editCommentHandler,
    handleDeleteModalClose,
    deleteCommentHandler,
    deleteCommentModalHandler,
    createCommentHandler,
    changeHiringProcessHandler,
    rejectApplicantHandler,
    openCommentInputHandler,
    setEditCommentText,
    setCommentText,
    getCommentsData,
    setEditCommentIndex,
    onOfferTermsFormDataChange,
    onAddOfferTermsClick,
    onMakeOfferClick,
    onCommentCancleClick,
    onEditCommentCancleClick,
  } = useHiringProcess();
  const { applicantHmsVideos, getJoineesNames } = props;

  return (
    <div className="hiring-procees-wrapper p-3 bg-white border border-radius-10 h-100">
      <div className="border-bottom mb-3 pb-3 d-flex align-items-center justify-content-between">
        <h3 className="font-weight-medium">Application Status</h3>
        {Array.isArray(hiringProgressInfoData) &&
          hiringProgressInfoData.map((item) =>
            item?.is_current_stage === true ? (
              <span
                className={`text-uppercase fs-smallest px-2 rounded d-inline-block
          ${item?.stage === "applied"
                    ? "label-blue"
                    : item?.stage === "assessment"
                      ? "label-light-green"
                      : item?.stage === "interview"
                        ? "label-voilet"
                        : item?.stage === "offer"
                          ? "label-yellow"
                          : item?.stage === "hired"
                            ? "label-green"
                            : "label-red"
                  }`}
              >
                {item?.stage}
              </span>
            ) : null
          )}
      </div>
      <ul className="d-flex flex-wrap align-items-center application-current-stage mb-4 text-capitalize">
        <li>
          <button
            className={
              activeStage === "applied"
                ? "active active-stage cursor-pointer"
                : currentTab === "applied"
                  ? "active cursor-pointer"
                  : "cursor-pointer w-100"
            }
            onClick={() => {
              currentTabHandler("applied");
            }}
          >
            Applied
          </button>
        </li>
        <li>
          <button
            className={
              activeStage === "assessment"
                ? "active active-stage cursor-pointer"
                : currentTab === "assessment"
                  ? "active cursor-pointer"
                  : "cursor-pointer w-100"
            }
            onClick={() => {
              currentTabHandler("assessment");
            }}
          >
            Assessment
          </button>
        </li>
        <li>
          <button
            className={
              activeStage === "interview"
                ? "active active-stage cursor-pointer"
                : currentTab === "interview"
                  ? "active cursor-pointer"
                  : "cursor-pointer w-100"
            }
            onClick={() => {
              currentTabHandler("interview");
            }}
          >
            Interview
          </button>
        </li>
        <li>
          <button
            className={
              activeStage === "offer"
                ? "active active-stage cursor-pointer"
                : currentTab === "offer"
                  ? "active cursor-pointer"
                  : "cursor-pointer w-100"
            }
            onClick={() => {
              currentTabHandler("offer");
            }}
          >
            Offer
          </button>
        </li>
        <li>
          <button
            className={
              activeStage === "hired"
                ? "active active-stage cursor-pointer"
                : currentTab === "hired"
                  ? "active cursor-pointer"
                  : "cursor-pointer w-100"
            }
            onClick={() => {
              currentTabHandler("hired");
            }}
          >
            Hired
          </button>
        </li>
        <li>
          <button
            className={
              activeStage === "rejected"
                ? "active active-stage cursor-pointer"
                : currentTab === "rejected"
                  ? "active cursor-pointer"
                  : "cursor-pointer w-100"
            }
            onClick={() => {
              currentTabHandler("rejected");
            }}
          >
            Rejected
          </button>
        </li>
      </ul>
      {/* application stage ends */}
      {stageLoading ? (
        <div className="p-4 text-center">
          <Spinner animation="border" variant="primary" size="lg" />
        </div>
      ) : (
        <div className="application-status pb-4">
          {hiringProgressInfoData &&
            hiringProgressInfoData.filter(
              (filterItem) => filterItem && filterItem.stage === currentTab
            ) &&
            hiringProgressInfoData
              .filter(
                (filterItem) => filterItem && filterItem.stage === currentTab
              )
              .map((item) => (
                <div className="row">
                  {Array.isArray(applicantHmsVideos) &&
                    applicantHmsVideos.length ? (
                    <div className="col-lg-12">
                      <div className="action w-100 mb-3 mt-1 label-voilet p-1 fs-smallest rounded font-weight-bold text-center">
                        <span className="mb-1">
                          Interview{" "}
                          {applicantHmsVideos[0]?.room_videos &&
                            applicantHmsVideos[0].room_videos.length
                            ? "completed"
                            : "scheduled"}{" "}
                          between {getJoineesNames(applicantHmsVideos[0])[0]}{" "}
                          and {getJoineesNames(applicantHmsVideos[0])[1]}
                        </span>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-6">
                    <p className="text-grey-4  mb-0 h4 font-weight-normal mb-2">
                      Stage
                    </p>
                    <p className="font-weight-medium mb-2 text-capitalize">
                      {item?.stage}
                    </p>

                    <p className="text-grey-4 mb-0 h4 font-weight-normal mb-2">
                      Date
                    </p>
                    <p className="font-weight-medium mb-2">
                      {new Date(item?.updated).toDateString().slice(4, 15)}
                    </p>
                  </div>
                  <div className="col-6">
                    {item?.assignee !== item?.owner && (
                      <div>
                        {" "}
                        <p className="text-grey-4 mb-0 h4 font-weight-normal mb-2">
                          Assignee
                        </p>
                        <p className="font-weight-medium d-flex align-items-center mentor-info">
                          <img
                            src={
                              item?.assignee_details?.user_meta_info
                                ?.profile_image
                                ? item?.assignee_details?.user_meta_info
                                  ?.profile_image
                                : "/assets/images/user.png"
                            }
                            alt="candidate img"
                            className="mr-2"
                          />
                          {item?.assignee_details &&
                            item.assignee_details?.full_name}
                        </p>
                      </div>
                    )}

                    <p className="text-grey-4 mb-0 h4 font-weight-normal mb-2">
                      Hiring Manager
                    </p>
                    <p className="font-weight-medium d-flex align-items-center owner-info mb-2">
                      <img
                        src={
                          item?.owner_details &&
                            item.owner_details?.user_meta_info &&
                            item.owner_details.user_meta_info?.profile_image
                            ? item?.owner_details &&
                            item.owner_details?.user_meta_info &&
                            item.owner_details.user_meta_info?.profile_image
                            : "/assets/images/user.png"
                        }
                        alt="candidate img"
                        className="mr-2"
                      />
                      {item?.owner_details && item.owner_details?.full_name}
                    </p>
                  </div>

                  {activeStage === "hired" && currentTab === "hired" ? (
                    <>
                      <div className="px-3 mt-4">
                        <h3 className="text-success">
                          The Candidate has been hired
                        </h3>
                      </div>
                    </>
                  ) : (
                    <div className="action col-12  mt-4">
                      {userType === "mentor" ? (
                        <>
                          {activeStage === "applied" ||
                            activeStage === "assessment" ? (
                            <button
                              className="btn btn-primary"
                              onClick={() => changeHiringProcessHandler(item)}
                            >
                              Move to Next Stage
                            </button>
                          ) : null}
                        </>
                      ) : (
                        <>
                          {activeStage === "offer" &&
                            (offerTermsAdded === false ? (
                              <button
                                className="btn btn-primary mr-2"
                                onClick={onAddOfferTermsClick}
                              >
                                Add Offer Terms
                              </button>
                            ) : (
                              <button className="btn btn-primary mr-2" disabled>
                                Add Offer Terms
                              </button>
                            ))}
                          <button
                            className="btn btn-outline-primary"
                            onClick={() => changeHiringProcessHandler(item)}
                            disabled={
                              activeStage !== currentTab ||
                              activeStage === "rejected"
                            }
                          >
                            {activeStage === "offer"
                              ? "Hire"
                              : "Move to Next Stage"}
                          </button>
                          <button
                            className="btn btn-outline-danger ml-2"
                            onClick={() => rejectApplicantHandler(item)}
                            disabled={activeStage === "hired"}
                          >
                            Reject
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              ))}
        </div>
      )}

      <div className="comments-wrapper pt-3 border-top">
        <div className="top d-flex align-items-center justify-content-between mb-3">
          <h3>Comments</h3>
          <span
            className="text-primary font-weight-semi cursor-pointer ml-2"
            onClick={openCommentInputHandler}
          >
            + Add Comments
          </span>
        </div>
        {openCommentInput ? (
          <>
            <div className="d-flex align-items-center py-3 border border-radius-10 px-3 mb-3">
              <input
                type="text"
                className="form-control py-2"
                placeholder="Add Comment..."
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              />

              <button
                className="btn btn-primary h-auto py-2 ml-3"
                onClick={() => {
                  createCommentHandler(
                    hiringProgressInfoData &&
                    hiringProgressInfoData.filter(
                      (item) => item.stage === currentTab
                    )[0]
                  );
                }}
              >
                {commentLoading ? (
                  <>
                    <Spinner animation="border" variant="white" size="lg" />
                  </>
                ) : (
                  <span className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faCheck} />
                    <span className="d-none d-md-block ml-md-2">Submit</span>
                  </span>
                )}
              </button>
              <button
                className="btn btn-outline-dark h-auto py-2 ml-3"
                onClick={() => {
                  onCommentCancleClick(
                    hiringProgressInfoData &&
                    hiringProgressInfoData.filter(
                      (item) => item.stage === currentTab
                    )[0]
                  );
                }}
              >
                <span className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faXmark} />
                  <span className="d-none d-md-block ml-md-2">Cancel</span>
                </span>
              </button>
            </div>
          </>
        ) : null}
        {Array.isArray(getCommentsData) &&
          getCommentsData &&
          getCommentsData.length ? (
          <>
            {getCommentsData &&
              getCommentsData.slice() &&
              getCommentsData.slice().reverse() &&
              getCommentsData
                .slice()
                .reverse()
                .map((commentItem) => (
                  <div className="mb-2 bg-grey border rounded-lg text-grey-4 p-3">
                    <div
                      className="comment-box d-flex align-items-start"
                      key={commentItem && commentItem.id}
                    >
                      <div className="user-img mr-3">
                        <img
                          src={
                            commentItem?.commenter &&
                              commentItem.commenter?.user_meta_info &&
                              commentItem.commenter.user_meta_info?.profile_image
                              ? commentItem?.commenter &&
                              commentItem.commenter?.user_meta_info &&
                              commentItem.commenter.user_meta_info
                                ?.profile_image
                              : "/assets/images/user.png"
                          }
                          alt="candidate img"
                          className="rounded-lg"
                        />
                      </div>
                      <div className="content flex-grow-1 fs-14">
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <div>
                            <h3 className="text-dark-2 mb-1 font-weight-medium">
                              {commentItem?.commenter &&
                                commentItem.commenter?.full_name}
                            </h3>
                            <p className="text-grey-4 mb-0">
                              {commentItem?.commenter &&
                                commentItem.commenter?.email}
                            </p>
                          </div>
                          <p className="d-flex align-items-center font-weight-normal h4 mb-0">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant=""
                                className="p-1 ml-3 mt- no-dropdown-arrow"
                              >
                                <FontAwesomeIcon
                                  className="h3"
                                  icon={faEllipsisV}
                                />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() =>
                                    deleteCommentModalHandler(commentItem)
                                  }
                                >
                                  Delete
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => {
                                    setEditCommentIndex(commentItem.id);
                                    setEditCommentText(commentItem.content);
                                  }}
                                >
                                  Edit
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="comment-text fs-14">
                      <p className="text-dark-2 mb-1">
                        {commentItem && commentItem.content}
                      </p>
                      <span>
                        {dateFormatter(commentItem && commentItem.updated)}
                      </span>{" "}
                      {"|"}{" "}
                      <span>
                        {new Date(
                          commentItem &&
                          commentItem.updated &&
                          commentItem.updated
                        ).toLocaleTimeString()}
                      </span>
                    </div>

                    {editCommentIndex === commentItem.id ? (
                      <>
                        <div className="d-flex align-items-center py-3 bg-grey px-3 rounded-lg mb-3">
                          <input
                            type="text"
                            className="form-control h-100 py-2"
                            placeholder="Add Comment..."
                            value={editCommentText}
                            onChange={(e) => setEditCommentText(e.target.value)}
                          />
                          <button
                            className="btn btn-primary h-auto py-2 ml-3"
                            onClick={() => {
                              editCommentHandler(commentItem);
                            }}
                          >
                            {editCommentLoading ? (
                              <>
                                <Spinner
                                  animation="border"
                                  variant="white"
                                  size="lg"
                                />
                              </>
                            ) : (
                              "Save"
                            )}
                          </button>
                          <button
                            className="btn btn-primary h-auto py-2 ml-3"
                            onClick={onEditCommentCancleClick}
                          >
                            Cancel
                          </button>
                        </div>
                      </>
                    ) : null}
                  </div>
                ))}
          </>
        ) : (
          <div className="msg-bg text-white p-3 border-6 mb-3 mt-4 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
            <p className="mb-0">
              <FontAwesomeIcon
                icon={faCircleInfo}
                className="text-white mr-2"
              />
              No Comments
            </p>
          </div>
        )}
      </div>

      <Modal
        show={deleteCommentModal}
        centered
        size="sm"
        onHide={handleDeleteModalClose}
        className="common-modal"
      >
        <Modal.Body className="py-5">
          <h2>Do you really want to delete this comment?</h2>
        </Modal.Body>
        <Modal.Footer className="justify-content-end">
          <Button variant="danger" onClick={deleteCommentHandler}>
            Delete
          </Button>
          <Button variant="primary" onClick={handleDeleteModalClose}>
            close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isOfferTermsModalOpen}
        centered
        size="xl"
        onHide={onAddOfferTermsClick}
        className="common-modal apply-job-modal schedule-interview-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Offer Amount and Terms</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-white">
          <div className="event-list">
            <div className="py-3 px-4 bg-grey-5 mb-0">
              <input
                className="form-control bg-transparent"
                type="number"
                placeholder="Enter Amount"
                defaultValue={offerTermsFormData?.amount}
                onChange={(e) => onOfferTermsFormDataChange(e)}
                name={"amount"}
              ></input>
            </div>
            <div className="py-3 px-4 bg-grey-5 mb-0">
              <TextEditor
                htmlData={offerTermsFormData?.terms_conditions}
                getHtmlData={(data) =>
                  onOfferTermsFormDataChange({
                    target: { value: data, name: "terms_conditions" },
                  })
                }
              />
            </div>
            <div className="action">
              <button
                className="btn btn-primary ml-4"
                onClick={() => onMakeOfferClick()}
              >
                {offerTermsAddedLoading ? (
                  <Spinner animation="border" variant="white" />
                ) : (
                  "Make Offer"
                )}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default HiringProcess;
